// FlightActionButtons — Presentational pair of buttons ("Find Flight by Route"
// and "I Have a Flight Number").
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icons, and the onMouseEnter/onMouseLeave hover handlers are identical to the
// source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Plane } from 'lucide-react';

export const FlightActionButtons = React.memo(function FlightActionButtons({ isCreating, onSearchClick, onLookupClick }) {
  return (
    <div style={{ marginBottom: '24px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
      <button
        type="button"
        onClick={onSearchClick}
        disabled={isCreating}
        style={{
          flex: '1 1 auto',
          padding: '12px 20px',
          fontSize: '14px',
          fontWeight: '600',
          color: 'white',
          background: '#0ea5e9',
          border: 'none',
          borderRadius: '8px',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          opacity: isCreating ? 0.5 : 1,
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => { if (!isCreating) e.target.style.background = '#0284c7'; }}
        onMouseLeave={(e) => { if (!isCreating) e.target.style.background = '#0ea5e9'; }}
      >
        <Plane size={18} />
        Find Flight by Route
      </button>
      <button
        type="button"
        onClick={onLookupClick}
        disabled={isCreating}
        style={{
          flex: '1 1 auto',
          padding: '12px 20px',
          fontSize: '14px',
          fontWeight: '500',
          color: '#0ea5e9',
          background: 'white',
          border: '2px dashed #0ea5e9',
          borderRadius: '8px',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          opacity: isCreating ? 0.5 : 1,
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          if (!isCreating) {
            e.target.style.background = '#f0f9ff';
            e.target.style.borderColor = '#0284c7';
          }
        }}
        onMouseLeave={(e) => {
          if (!isCreating) {
            e.target.style.background = 'white';
            e.target.style.borderColor = '#0ea5e9';
          }
        }}
      >
        <Plane size={18} />
        I Have a Flight Number
      </button>
    </div>
  );
});

export default FlightActionButtons;
